import { Component, OnInit } from '@angular/core';
import { ModalContainerService, BaseModalUpdateComponent, BaseInlineContainer, BaseEntity, InlineContainerService, UserService } from 'yt-ng-framework';
import { List } from 'immutable';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sist-radnih-mesta-stavka-update-container',
  templateUrl: './sist-radnih-mesta-stavka-update-container.component.html'
  , providers: [
    InlineContainerService
  ] 
})
export class SistRadnihMestaStavkaUpdateContainerComponent<T extends BaseEntity> 
 extends BaseInlineContainer<T> {

  constructor(
    inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService
  ) {
    super(inlineContainerService, activatedRoute, userService);
   }

   tempItems: List<T>

   setItems(items){
   this.tempItems = items;
   }
   }
   